import { render, staticRenderFns } from "./OnboardingSummaryTab.vue?vue&type=template&id=8105b942&"
import script from "./OnboardingSummaryTab.vue?vue&type=script&lang=js&"
export * from "./OnboardingSummaryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports